module Hereabout.UI.Components.RawHTMLComponent where

import Prelude

import Data.Const (Const)
import Data.Maybe (Maybe(..))
import Effect (Effect)
import Effect.Class (class MonadEffect, liftEffect)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Properties as HP
import Hereabout.UI.Bulma.Classes as Bulma
import Web.HTML (HTMLElement)

foreign import _setHTML :: HTMLElement -> String -> Effect Unit

type State = 
  { html :: String 
  }

type Input = 
  { html :: String 
  }

data Action 
  = Initialize
  | Receive Input

type Slot id = forall q o. H.Slot q o id


elRef :: H.RefLabel
elRef = H.RefLabel "raw-html-content"

component :: forall m q cs. MonadEffect m => H.Component q Input cs m
component = 
  H.mkComponent
    { initialState: identity
    , render
    , eval: H.mkEval H.defaultEval
      { handleAction = handleAction
      , initialize = Just Initialize
      , receive  = Just <<< Receive
      }
    }
  where
  handleAction :: Action -> H.HalogenM State Action () cs m Unit
  handleAction = case _ of
    Initialize -> do
      state <- H.get
      H.getHTMLElementRef elRef >>= case _ of
        Nothing -> pure unit
        Just el -> do
          liftEffect $ _setHTML el state.html
      pure unit

    Receive input -> H.modify_ _ 
      { html = input.html
      }

  render :: State -> H.ComponentHTML Action () m
  render state =  
    HH.div 
      [ HP.ref elRef, HP.classes [ Bulma.content ] ] 
      []
